import { ForceUpdateService } from '@mathflat/shared/@modules/forceUpdate/forceUpdateService'
import { markPendingToast } from '@mathflat/shared/@modules/forceUpdate/postUpdateToast'
import { createLatestReleaseIdFetcher } from '@mathflat/shared/@modules/forceUpdate/releaseCheck'

import { envUtils } from '@/utils/envUtils'
import navigationUtils from '@/utils/navigationUtils'

export const forceUpdateService = new ForceUpdateService({
  getMyReleaseId: () => envUtils.releaseId,
  getLatestReleaseId: createLatestReleaseIdFetcher({
    isDebugOverrideAllowed: () => !envUtils.isLive,
  }),
  navigate: (destinationUrl) => navigationUtils.navigate(destinationUrl),
  onBeforeReload: markPendingToast,
})
